import { Loan } from "../../../../domain/models";
import { LoanStatus, PaymentMethod } from "../../../../domain/models/loan";
import { LoanEntity } from "../entities";
import { DeviceInfoMapper, LoanApplicationMapper, ProviderContractMapper, UserMapper, ModelInfoMapper, LoanMetadataMapper } from "./";

export default class LoanMapper {
  static toModel(entity: LoanEntity): Loan {
    return new Loan({
      id: entity.id,
      creditScore: entity.credit_score,
      createdAt: entity.created_at,
      days: entity.days,
      estimatedPaymentDate: entity.estimated_payment_date,
      approvedAt: entity.approved_at,
      depositedAt: entity.deposited_at,
      daysInArrears: entity.days_in_arrears,
      status: this.statusCdToLoanStatus(entity.status_cd),
      consecutive: entity.consecutive,
      amountApproved: entity.amount_approved,
      amountToPay: entity.amount_to_pay,
      chargedInterest: entity.charged_interest,
      chargedMaintenanceFee: entity.charged_maintenance_fee,
      chargedIvaFee: entity.charged_iva_fee,
      maintenanceFeeCost: entity.maintenance_fee_cost,
      negotiatedAmountToPay: entity.negotiated_amount_to_pay,
      negotiatedPaymentDate: entity.negotiated_payment_date,
      annualEffectiveInterestRate: entity.annual_effective_interest_rate,
      amountPaid: entity.amount_paid,
      paidAt: entity.paid_at,
      paymentMethod: (entity.payment_method_cd !== undefined && entity.payment_method_cd !== null)  ? this.paymentMethodCdToEnum(entity.payment_method_cd) : undefined,
      fees: entity.fees,
      approvedConsecutive: entity.approved_consecutive,
      invoiceConsecutive: entity.invoice_consecutive,
      user: UserMapper.toModel(entity.user),
      loanApplication: LoanApplicationMapper.toModel(entity.loan_application),
      modelInfo: entity.model_info ? ModelInfoMapper.toModel(entity.model_info) : undefined,
      acceptedOnlineSignature: entity.accepted_online_signature,
      signedContract: entity.signed_contract,
      providerContract: entity.provider_contract ? ProviderContractMapper.toModel(entity.provider_contract) : undefined,
      deviceInfo: entity.device_info ? DeviceInfoMapper.toModel(entity.device_info) : undefined,
      metadata: entity.metadata ? LoanMetadataMapper.toModel(entity.metadata) : undefined,
    });
  }

  static statusCdToLoanStatus = (statusCd: number): LoanStatus => {
    switch (statusCd) {
      case 0:
        return LoanStatus.open;
      case 1:
        return LoanStatus.approved;
      case 3:
        return LoanStatus.deposited;
      case 4:
        return LoanStatus.paid;
      case 5:
        return LoanStatus.rejected;
      default:
        throw new Error(`Unknown status code: ${statusCd}`);
    }
  }

  static paymentMethodCdToEnum = (paymentMethodCd: number): PaymentMethod => {
    switch (paymentMethodCd) {
      case 0:
        return PaymentMethod.transfer;
      case 1:
        return PaymentMethod.online;
      default:
        throw new Error(`Unknown payment method: ${paymentMethodCd}`);
    }
  }
}